/* eslint-disable no-console */
import {Flex} from 'antd';
import React, {memo} from 'react';

import BarChart from '../../../components/Chart/BarChart/BarChart';
import CompositeAreaLineChart from '../../../components/Chart/CompositeChart/CompositeAreaLineChart';
import LineChart from '../../../components/Chart/LineChart/LineChart';
import PieChart from '../../../components/Chart/PieCharts/PieChart';
import PieChartMulti from '../../../components/Chart/PieCharts/PieChartMulti';
import ProgressChart from '../../../components/Chart/PieCharts/ProgressChart';
// import {sortBy} from '../../../shared/commonFunctions';
import {chartType} from '../interface/IChart';

const ChartSwitch: React.FC<{
  chartType: chartType;
  data: {mainData?: any; subData?: any[]};
  chartProps?: any;
  customLabel?: string;
  isCost?: boolean;
  labelType?: 'value' | 'percent';
  convertToTJ?: boolean;
}> = ({
  chartType,
  data: {mainData = {}, subData = []},
  chartProps = {},
  customLabel,
  labelType,
  isCost = false,
  convertToTJ = false
}) => {
  switch (chartType) {
    case 'donut':
      return (
        <PieChartMulti
          data={subData}
          showLegend={false}
          center={true}
          showLabel={false}
          {...chartProps}
        />
      );
    case 'pie':
      return (
        <PieChart
          data={subData}
          showLabel={false}
          showLegend={false}
          noStrokeWidth={true}
        />
      );
    case 'progress':
      return (
        <ProgressChart
          data={subData}
          mainData={mainData}
          customLabel={customLabel}
          labelType={labelType}
          convertToTJ={convertToTJ}
        />
      );
    case 'progressWithOutTotal':
      return (
        <ProgressChart
          data={subData}
          mainData={mainData}
          customLabel={customLabel}
          showLabel={false}
        />
      );
    case 'multiProgress':
      return (
        <Flex
          vertical={false}
          style={{width: '100%', height: '100%', flex: 1.5}}
        >
          {subData?.map((item) => {
            const total = mainData.value;
            const {value, ...restItem} = item;
            const totalPer = value / total;

            return (
              <ProgressChart
                data={[{value: totalPer * 100, ...restItem}]}
                mainData={{value: 100 - totalPer * 100}}
                customLabel={customLabel}
                showLabel={false}
                withTotal={true}
                key={item?.dataId}
              />
            );
          })}
        </Flex>
      );
    case 'bar':
      return <BarChart data={subData} mainData={mainData} />;
    case 'barReverse':
      return <BarChart data={subData} isColorReverse={true} />;
    case 'composite':
      return <CompositeAreaLineChart data={subData} mainData={mainData} />;
    case 'compositeStraight':
      return (
        <CompositeAreaLineChart
          data={subData}
          mainData={mainData}
          type="compositeStraight"
        />
      );
    case 'lineWithoutArea':
      return (
        <CompositeAreaLineChart
          data={subData}
          mainData={mainData}
          type="lineWithoutArea"
        />
      );
    case 'pieInside':
      return (
        <PieChartMulti
          data={subData}
          inside={true}
          center={true}
          customLabel={customLabel}
        />
      );
    case 'pieInsideWithTotal':
      return (
        <PieChartMulti
          data={subData}
          inside={true}
          center={true}
          mainData={mainData}
          showCenterLabel={true}
          customLabel={customLabel}
        />
      );
    case 'pieInsideWithTotalExtra':
      return (
        <PieChartMulti
          data={subData}
          inside={true}
          center={true}
          mainData={mainData}
          showCenterLabel={true}
          customLabel={customLabel}
          addExtra
        />
      );
    case 'line':
      return <LineChart data={subData} mainData={mainData} isCost={isCost} />;
    case 'lineMinMax':
      return <LineChart data={subData} mainData={mainData} minMax={true} />;
  }
};

export default memo(ChartSwitch);
